import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { x: "0.5", y: "0.5", width: "23", height: "23", rx: "2.5", fill: "black", stroke: "black" }),
    React.createElement("path", { d: "M6 12.4615L9.97059 16.5L19.5 6", stroke: "white", strokeWidth: "1.5" })), 'CheckboxOn');
